import React from 'react';
import { CacheProvider } from '@emotion/react';
import EmotionCache from './emotion-cache';

const cache = EmotionCache();

export const wrapRootElement = ({ element }) => <CacheProvider value={cache}>{element}</CacheProvider>;
